/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shared_CustomizeInputs */

const en_shared_customize = /** @type {(inputs: Shared_CustomizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customize`)
};

const de_shared_customize = /** @type {(inputs: Shared_CustomizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anpassen`)
};

const es_shared_customize = /** @type {(inputs: Shared_CustomizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizar`)
};

const fr_shared_customize = /** @type {(inputs: Shared_CustomizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personnaliser`)
};

/** @type {(inputs: Shared_CustomizeInputs) => LocalizedString} */
const it_shared_customize = en_shared_customize;

/** @type {(inputs: Shared_CustomizeInputs) => LocalizedString} */
const pt_br2_shared_customize = en_shared_customize;

/** @type {(inputs: Shared_CustomizeInputs) => LocalizedString} */
const pl_shared_customize = en_shared_customize;

/** @type {(inputs: Shared_CustomizeInputs) => LocalizedString} */
const hu_shared_customize = en_shared_customize;

/** @type {(inputs: Shared_CustomizeInputs) => LocalizedString} */
const ro_shared_customize = en_shared_customize;

/**
* | output |
* | --- |
* | "Customize" |
*
* @param {Shared_CustomizeInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const shared_customize = /** @type {((inputs?: Shared_CustomizeInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_CustomizeInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_customize(inputs)
	if (locale === "de") return de_shared_customize(inputs)
	if (locale === "es") return es_shared_customize(inputs)
	if (locale === "fr") return fr_shared_customize(inputs)
	if (locale === "it") return it_shared_customize(inputs)
	if (locale === "pt-BR") return pt_br2_shared_customize(inputs)
	if (locale === "pl") return pl_shared_customize(inputs)
	if (locale === "hu") return hu_shared_customize(inputs)
	return ro_shared_customize(inputs)
});
export { shared_customize as "shared.customize" }